import { StudioRenderMode } from '@/Pages/Graph/src/hooks/useStudioRenderMode';

export function isHostedUrl(url: string | null) {
  if (!url) return false;
  try {
    const parsed = new URL(url);
    return parsed.hostname.endsWith('.langgraph.app');
  } catch {
    return false;
  }
}

export const graphPublic = (location: Location) => {
  const params = new URLSearchParams(location.search);
  if (
    params.get('hostProjectId') ||
    params.get('organizationId') ||
    params.get('datasetId') != null ||
    params.get('render') === StudioRenderMode.TRACE
  )
    return false;
  if (isHostedUrl(params.get('baseUrl'))) return false;
  return true;
};
